module.exports = __webpack_public_path__ + "img/main-992.4452764a.png";